const values = [
  "bundlue_bg_brown",
  "bundlue_bg_green",
  "bundlue_bg_red",
];
export default values;
